import { Sun, Moon } from 'lucide-react';
import { useTheme } from '../context/ThemeContext';

/**
 * Accessible theme toggle button.
 * Props:
 *   variant: 'light' | 'dark' - forces a color scheme for the button chrome
 *            (useful on dark navbars). Default: auto (follows theme).
 */
export default function ThemeToggle({ variant }) {
  const { theme, toggleTheme } = useTheme();

  const isOnDarkSurface = variant === 'dark';
  const classes = isOnDarkSurface
    ? 'p-2 rounded-md text-white/70 hover:text-white hover:bg-white/10 transition-colors'
    : 'p-2 rounded-md text-muted-foreground hover:text-foreground hover:bg-secondary transition-colors';

  return (
    <button
      type="button"
      onClick={toggleTheme}
      className={classes}
      aria-label={theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
      title={theme === 'dark' ? 'Light mode' : 'Dark mode'}
    >
      {theme === 'dark' ? (
        <Sun className="w-5 h-5" />
      ) : (
        <Moon className="w-5 h-5" />
      )}
    </button>
  );
}
